import type { InboxMessageFragment } from "@qw/graphql";
import { Collapsible, CollapsibleContent } from "@qw/ui";
import { useState } from "react";
import { isFilteredAttachmentMimeType } from "@/constants/filtered-extensions";

import { messageAnchorId } from "./message-anchor";
import { MessageAttachments } from "./message-attachments";
import { MessageDetail } from "./message-detail";
import { MessageSender } from "./message-sender";

export const Message = ({ message }: { message: InboxMessageFragment }) => {
  const { attachments } = message;
  const fileUploads = attachments.map((a) => a.fileUpload);
  const filteredAttachments = fileUploads.filter((f) => !isFilteredAttachmentMimeType(f.mimeType));
  // Every message opens. Folding one is a deliberate act by the reader and stays session-only —
  // nothing about the message (read state, position in the thread) may collapse it on their behalf.
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Collapsible id={messageAnchorId(message.id)} open={isOpen} onOpenChange={setIsOpen} className="group">
      <MessageSender message={message} isMessageOpen={isOpen} />
      {/* No `asChild` here: Radix measures the content element through its own ref, which
          `MessageDetail` cannot forward because it renders a different root per state. On a message
          that starts open, the dropped ref leaves Radix latched open and folding stops working. */}
      <CollapsibleContent>
        <MessageDetail messageId={message.id} />
      </CollapsibleContent>
      {filteredAttachments.length > 0 && <MessageAttachments files={filteredAttachments} />}
    </Collapsible>
  );
};
